import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const MySelect = ({options, optionDefault, optionsDefault, nameField, label, labelId, id, value, onChange, ...rest}) => {
  return (
    <FormControl 
		// variant="outline" 
		size='small' 
		sx={{ m: 1, minWidth: 120 }}
	>
        {label ? <InputLabel id={labelId}>{label}</InputLabel> : ''}
        <Select
			// className='selectSuccess'
			className={value ? 'selectSuccess' : ''} // selectError
			labelId={labelId}
			id={id}
			value={value}
			onChange={event => onChange(event.target.value)}
			label={label}
			{...rest}
        >
            {/* {optionDefault ? <MenuItem key={optionDefault.value} value={optionDefault.value}>{optionDefault.name}</MenuItem> : <MenuItem></MenuItem>} */}
            {optionDefault ? <MenuItem key={optionDefault.value} value={optionDefault.value}>{optionDefault.name}</MenuItem> : null}
			{ // Якщо кілька базових опцій. Важливо, щоб не було звичайного обʼєкту
				optionsDefault && optionsDefault.length > 0 && !optionDefault ?
					optionsDefault.map(option => {
						return <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>
					})
				: null
			}
            {/* {options.map(option => 
                <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
            )} */}
            {options.map(option => {
				if (option) {
					return <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>
				} else {
					return null
				}
			})}
        </Select>
        {/* <FormHelperText>Here's my helper text</FormHelperText> */}
      </FormControl>
  )
}

export default MySelect